import { getIconForField } from 'utils/icon_mapper';
import Money from 'utils/money';

export const formatDynamicMessage = (data, indent = 0) => {
  if (!data || typeof data !== 'object') {
    return 'No se encontró información.';
  }

  let message = '';
  const indentation = '  '.repeat(indent);
  const ignoredKeys = ['_id', '__v'];

  const processArrayItem = (item) => {
    message += `${indentation}- ${formatDynamicMessage(item, indent + 1)}\n`;
  };

  for (const [key, value] of Object.entries(data)) {
    if (ignoredKeys.includes(key)) continue;

    const icon = getIconForField(key);
    const label = `${icon} ${capitalize(key)}`;

    if (value === null || value === '') {
      continue;
    }

    const normalizedKey = key?.toLowerCase();
    const messageKeys = ['mensagem', 'message', 'mensagens', 'mensaje', 'mssg'];

    if (messageKeys.includes(normalizedKey)) {
      const segment = Array.isArray(value)
        ? value.map((msg) => `${msg}\n`).join('')
        : `${value}\n`;

      message += segment;
      continue;
    }

    if (Array.isArray(value)) {
      if (value.length === 0) continue;

      const isPrimitiveArray = value.every(
        (item) => typeof item === 'string' || typeof item === 'number'
      );

      if (isPrimitiveArray) {
        const joined = value.join(', ');
        message += `${indentation}${label}: ${joined}\n`;
      } else {
        message += `${indentation}${label}:\n`;
        value.forEach(processArrayItem);
      }
    } else if (typeof value === 'object') {
      if ('subunits' in value && 'iso' in value) {
        const money = new Money(value);
        message += `${indentation}${label}: ${money.format()}\n`;
      } else {
        message += `${indentation}${label}:\n${formatDynamicMessage(value, indent + 1)}\n`;
      }
    } else if (typeof value === 'string' && value.startsWith('http')) {
      if (/\.(jpeg|jpg|png|gif|webp)$/i.test(value)) {
        message += `${indentation}${label}:\n`;
        message += `${indentation}<img src="${value}" alt="${key}" class="chat-img-preview" />\n`;
      } else {
        message += `${indentation}${label}: <a href="${value}" target="_blank" rel="noopener noreferrer">Ver enlace</a>\n`;
      }
    } else {
      message += `${indentation}${label}: ${value}\n`;
    }
  }

  return message.trim();
};

const capitalize = (text) => {
  if (!text) return '';
  return String(text).charAt(0).toUpperCase() + String(text).slice(1).replaceAll('_', ' ');
};